import { produce } from 'immer';
import * as types from './collectionTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    records: [],
    totalRecords: 0,
    loading: true,
};

const actionHandlers = {
    [types.GET_COLLECTIONS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_COLLECTIONS.SUCCESS]: produce(
        (draft, { total, collections }) => {
            const records = collections.map((item) => ({
                ...item,
                rulesLength: item?.rules?.length || 0,
                createdBy: item?.createdBy?.firstName
                    ? `${item?.createdBy?.firstName} ${item?.createdBy?.lastName}`
                    : '',
            }));
            draft.records = records;
            draft.totalRecords = total;
            draft.loading = false;
        }
    ),
    [types.GET_COLLECTIONS.FAILURE]: produce((draft) => {
        draft.loading = false;
    }),
    [types.RESET_COLLECTIONS]: produce((draft) => {
        draft.records = [];
        draft.totalRecords = 0;
        draft.loading = true;
    }),
};

export default createReducer(initialState, actionHandlers);
